export { default } from './TextWithImageBlock'
